module.exports = __webpack_public_path__ + "img/initiative_grey.da543bcd.svg";